import Fire_base from '../Config/Fire_base'



export const GetDataUser = async (uuid) => {
    let getDataUser = {}
    await Fire_base.firestore().collection('users').doc(uuid).get()
        .then(
            res=> getDataUser = res.data()
        )
        .catch(
            error=>console.log(error)
        )

    return getDataUser
}

